import {API_URL} from "../config";
import axios from "../utils/axios";

class AuditLogRepository
{
    getAll(filter) {
        return axios.get(API_URL + "/AuditLog/List?", { params: filter });
    }

    getForParkingEvent(id) {
        return axios.get(API_URL + "/AuditLog/ParkingEvent/" + id);
    }

    getForFine(id) {
        return axios.get(API_URL + "/AuditLog/Fine/" + id);
    }

    getVerificationStatuses(filter) {
        return axios.get(API_URL + "/AuditLog/VerificationStatuses");
    }
}

export default AuditLogRepository;